<div class="copyright-box" matDialogContent>
  <app-icon-button Icon="close" (Click)="close()" class="close-dialog" Appearance="default" />
  <div class="copyright-icon-box">
    <mat-icon>public_off</mat-icon>
  </div>
  <h6>این محتوا در لوکیشن شما در دسترس نیست.</h6>
  <h6>Unavailable for legal reasons</h6>
</div>
